import { kitItemTypes } from '../constants/enums';

const expandKitSelection = (selectedKits = [], selectedItems = [], kitsList = []) => {
  const kits = [];
  const items = [...(selectedItems || [])];
  const parentKits = [];

  (selectedKits || []).forEach((selectedKit) => {
    const kit = (kitsList || []).find((candidate) => candidate.id === selectedKit.id);

    if (kit?.isParent) {
      parentKits.push(kit.id);
      kit.children?.forEach((child) => {
        const equipment = {
          id: child.id,
          quantity: child.quantity,
          parentKitId: kit.id,
        };

        if (child.type === kitItemTypes.KIT.value) {
          kits.push(equipment);
        }

        if (child.type === kitItemTypes.ITEM.value) {
          items.push(equipment);
        }
      });
      return;
    }

    if (!kits.some((candidate) => candidate.id === selectedKit.id)) {
      kits.push(selectedKit);
    }
  });

  return { kits, items, parentKits };
};

export const expandCaseEquipment = (caseData = {}, kitsList = []) => {
  const primary = expandKitSelection(caseData.kits, caseData.items, kitsList);
  const additional = expandKitSelection(
    caseData.additionalKits,
    caseData.additionalItems,
    kitsList,
  );

  return {
    kits: primary.kits,
    items: primary.items,
    parentKits: primary.parentKits,
    additionalKits: additional.kits,
    additionalItems: additional.items,
    additionalParentKits: additional.parentKits,
  };
};
